<template>
  <div id="diy-dialog-import">
    <!-- 导入的弹出框 -->
    <div class="line">
      <div class="title">导入方式:</div>
      <div class="value">
        <el-radio-group v-model="data.way" @change="changeModel">
          <el-radio
            :label="item.value"
            v-for="(item, index) in data.wayOptions"
            :key="index"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
      </div>
    </div>
    <div class="line">
      <div class="title">模板下载:</div>
      <div class="value">
        <div class="link" @click="downloadModelFile">模板下载</div>
      </div>
    </div>
    <div class="line">
      <div class="title">文件上传:</div>
      <div class="value">
        <div class="upload">
          <div class="fk">
            <el-upload
              class="upload-demo"
              :action="action"
              :headers="headers"
              :show-file-list="false"
              multiple
              :data="{
                title: '用户头像',
              }"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
            >
              <span>选择文件</span>
            </el-upload>
          </div>
          <div class="tip">
            仅支持{{
              data.way == "0" ? ".xlsx、.xls" : ".doc、.docx"
            }}文件,请先下载导入模板!
          </div>
          <div class="link">{{ data.fileName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "diy_dialog_import",
  props: {
    importData: {
      type: Object,
      default: function () {
        return {
          way: "0",
        };
      },
    },
  },
  data() {
    return {
      data: this.importData,
      tip: "",
      action: this.$baseurl + "/uploadFile",
      headers: {
        token: "",
      },
    };
  },
  watch: {
    importData() {
      this.data = this.importData;
    },
    data(newValue) {
      this.$emit("showImport", this.data);
    },
  },
  methods: {
    /**
     模板下载
     */
    downloadModelFile() {
      let type = "0";
      switch (this.data.type) {
        case "0":
          // 职业技能鉴定模板
          type = this.data.way == "0" ? "1" : "0";
          break;
        case "1":
          // 上岗考核/专业题库模板
          type = this.data.way == "0" ? "3" : "2";
          break;
        case "2":
          // 法规考核/条令考核模板
          type = this.data.way == "0" ? "5" : "4";
          break;
        case "3":
          // 上岗证考核学员实操模板
          type = this.data.way == "0" ? "8" : "8";
          break;

        default:
          // 其他导入
          type = this.data.type;
          break;
      }
      window.open(this.$baseurl + "/downloadModelFile?type=" + type);
    },
    /**
     * 导入前文件格式判断  只能上传exel格式数据
     */
    beforeAvatarUpload(file) {
      console.log(file.type);
      let isJPG = false;
      let errorString = "";
      if (this.data.way == "0") {
        isJPG =
          file.type == "application/vnd.ms-excel" ||
          file.type ==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        errorString = "文件上传仅支持.xlsx、.xls文件格式!!!";
      } else {
        isJPG =
          file.type == "application/msword" ||
          file.type ==
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        errorString = "文件上传仅支持.doc、.docx文件格式!!!";
      }
      if (!isJPG) {
        this.$message.error(errorString);
      }
      return isJPG;
    },
    /**
     * 模板上传成功
     */
    handleAvatarSuccess(response, file, fileList) {
      console.log(response);
      if (response.code == "200") {
        this.data.fileName = file.name;
        this.data.fileUrl = response.result.path;
      }
    },
    /**
     * 切换导入方式
     * 清空文件url和名称
     */
    changeModel(val) {
      this.data.fileName = "";
      this.data.fileUrl = "";
    },
  },
};
</script>

<style lang="less" scoped>
#diy-dialog-import {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  > .line {
    width: 100%;
    height: auto;
    line-height: 35px;
    margin-bottom: 8px;
    display: flex;
    font-size: 15px;
    > .title {
      width: 20%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      text-align: center;
      margin-right: 8px;
      font-weight: bold;
    }
    > .value {
      width: 0;
      flex: 1;
      height: auto;
      text-align: center;
      display: flex;
      align-items: center;
      .link {
        color: #248aff;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        transition: 0.3s;
        &:hover {
          text-decoration: underline;
          text-underline-offset: 5px;
        }
      }
      > .upload {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        .fk {
          width: 180px;
          height: 180px;
          background-color: #afafaf;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #fff;
          cursor: pointer;
          i {
            margin-right: 8px;
          }
        }
        > .tip {
          width: 100%;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          color: #ff5537;
          margin-top: 5px;
        }
      }
    }
  }
}
</style>